import { render } from "./CommunitySection.vue?vue&type=template&id=4ddc5987&scoped=true"
const script = {}

import "./CommunitySection.vue?vue&type=style&index=0&id=4ddc5987&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ddc5987"]])

export default __exports__